/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AnnouncementsChatIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABn0lEQVR4nNWVzS4EQRDHGyEkgqt4AnGQeAAcsVsfc+itmjhshOxBPIGIcZAQV1eeRXysuysiEi4EibhYexhpOxlfu2PX7EpU0ofJVNev619V3caksIl8vhtZAyQ5BdISsl4A6Ya1ttekNWttD5IeIWv4fckJUX4gFQBI1qoHjxbpdkqAnicCWB6CIGhPAyglAzS01vb/GoCsZz9k8FhXBkEQtBPJJLLuuLTR00wECJIAQHJjre2qLQHoCJBuAcnVp42s+3GLkhz+INNKHJDIn3HBgPS+orG81NqYJX8xhrCsujlA1nIV3+sPRXs/aSRB0snKwLJkjGlrpGhhA4AwkqsIrH4mY4estR1NB2DtAt+1FIBRjL8FQGNFDhsGZFmmK21a0a/pgK8WO5NcthRgjGlDzI0DyW6zAc/OcWpqtu/tG9WrtKA+AetejcmtHwCsB5FEx+5ii5sAc3Puv+fNDgLJsrtafgXIeLlRJL39NECsxUKh0PnRj1mGq0CeTT3m5CHyF5B1E0jm3TtczS/r5cZcpu6CdA8RkK7XBfgX9grwlEBfq60AegAAAABJRU5ErkJggg==)
 */
export const AnnouncementsChatIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M22.84 6.03a.57.57 0 0 0 .04.5l1.04 1.67c.22.35-.03.8-.44.8h-4.92A4.53 4.53 0 0 1 14 4.5C14 2.02 16.04 0 18.56 0a4.53 4.53 0 0 1 4.28 6.03Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M22 11.5a.5.5 0 0 0-.5-.5h-2.94a6.56 6.56 0 0 1-6.29-4.63.54.54 0 0 0-.68-.37L6.33 7.88a.5.5 0 0 0-.33.47v10.09a3 3 0 0 0 2.27 2.9l.62.16c1.57.4 3.15-.56 3.55-2.12a.92.92 0 0 1 1.23-.63l2.36.94c.42.27.79.62 1.07 1.03A3 3 0 0 0 19.56 22h.94c.83 0 1.5-.67 1.5-1.5v-9Zm-10.97 6.3L8 16.7v1.73a1 1 0 0 0 .76.97l.62.15c.5.13 1-.17 1.12-.67.1-.41.29-.78.53-1.1Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M2 10c0-1.1.9-2 2-2h.5c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5H4a2 2 0 0 1-2-2v-4Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
